import "./NavbarStyles.css";

import React, { useState } from 'react';
import { Link } from "react-router-dom";

import { FaBars, FaTimes } from "react-icons/fa";
import { HashLink } from 'react-router-hash-link';
import { FaLinkedin } from "react-icons/fa6";
import { FaGithub } from "react-icons/fa";
import { MdOutlineDesignServices } from "react-icons/md";
import { FaCat } from "react-icons/fa";



const Navbar = () => {

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 100) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  window.addEventListener("scroll", changeColor);


  return (
    <div className={color ? "header header-bg" : "header"}>

      <h1>            <HashLink smooth to="/#home-top">Charlotte Fritz</HashLink> </h1>

      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li>
          <HashLink smooth to="/#home-top">Home</HashLink>
        </li>
        <li>
          <HashLink smooth to="/about#about-top">About</HashLink>
        </li>
        <li>
          <HashLink smooth to="/project#project-top">Portfolio</HashLink>
        </li>
        {/* <li>
          <a href="#bottom-heading" >Say hello</a>
        </li> */}
        <li>
          <HashLink smooth to="https://www.linkedin.com/in/charlottepfritz">
            <FaLinkedin style={{ marginRight: '1px', fontSize: '30px' }} />
          </HashLink>
        </li>
        <li>
          <HashLink smooth to="https://github.com/charlottepfritz">
            <FaGithub style={{ marginLeft: '1px', fontSize: '30px' }} />
          </HashLink>
        </li>
        <li>
          <HashLink smooth to="https://grey-cat-creative-design-agency.netlify.app">
            <MdOutlineDesignServices style={{ marginLeft: '1px', fontSize: '30px' }} />
          </HashLink>
        </li>
      </ul>
      <div className="hamburger" onClick={handleClick}>
        {click ? (<FaTimes size={20} style={{ color: "#fff" }} />
        ) : (<FaBars size={20} style={{ color: "#fff" }} />
        )}
      </div>

    </div>
  )
}

export default Navbar